import React, { useMemo, Fragment } from 'react';
import { graphql } from 'gatsby';
import { Container, className, Row, Col, Heading } from 'design-system';
import style from './styles.module.scss';
import { ServicesButtons } from '../ServicesSection';
import ButtonComponent from '../ButtonComponent';

function formatServices(services) {
    return services
        .filter(
            (s) => (!!s?.treeChildren?.length || !!s?.page?.slug) && !s?.hide,
        )
        .map((s) => ({
            ...s,
            treeChildren: s.treeChildren?.length
                ? formatServices(s.treeChildren)
                : [],
        }));
}

export default function ServicesBoxSection({
    title,
    serviceChilds,
    services,
    sectorServices,
    boxWithMargins,
}) {
    const serviceBlocks = useMemo(() => {
        let items = [];

        if (serviceChilds?.length) {
            let allChilds = [];

            serviceChilds.forEach((sc) => {
                allChilds = [
                    ...allChilds,
                    ...formatServices(
                        sc.treeChildren?.length ? sc.treeChildren : [sc],
                    ),
                ];
            });

            items = [
                {
                    treeChildren: allChilds.sort(
                        (a, b) => a.position - b.position,
                    ),
                },
            ];
        } else if (sectorServices?.length) {
            items = [
                {
                    treeChildren: sectorServices.filter(
                        (ss) => !!ss.page?.slug && !ss?.hide,
                    ),
                },
            ];
        } else if (services?.length) {
            items = formatServices(services);
        }

        items = items.map((item) => {
            item.treeChildren = item.treeChildren?.map((subitem) => {
                subitem.hasChild = !!subitem.treeChildren?.length;
                return subitem;
            });

            item.hasChild = !!item.treeChildren?.find(
                (subitem) => subitem.hasChild,
            );

            return item;
        });

        if (items.length === 1 && !items[0].treeChildren.length) {
            return null;
        }

        return items;
    }, [serviceChilds, services, sectorServices]);

    return (
        <>
            {serviceBlocks && (
                <>
                    {boxWithMargins ? <div {...className('mb-20')} /> : null}
                    {serviceBlocks.map((service, i) => {
                        return (
                            <section
                                key={i}
                                data-datocms-noindex
                                {...className(
                                    `${
                                        boxWithMargins
                                            ? style['services__box']
                                            : ''
                                    }`,
                                )}>
                                <Container>
                                    <Row>
                                        <Col
                                            offset={{ lg: 1 }}
                                            col={{ lg: 10 }}>
                                            <div
                                                {...className(
                                                    `shadow-sm ${style.wrapper}`,
                                                )}>
                                                {title ? (
                                                    <Heading
                                                        tag="h3"
                                                        className={`subtitle text-uppercase font-weight-bold mb-5 ${style.title}`}>
                                                        {title}
                                                    </Heading>
                                                ) : null}
                                                {service.page ? (
                                                    <div
                                                        {...className(
                                                            `${style['button__first__wrapper']}`,
                                                        )}>
                                                        <ButtonComponent
                                                            buttonClassName={
                                                                style.button
                                                            }
                                                            button={{
                                                                type: 'secondary',
                                                                block: true,
                                                                label: service.title,
                                                                link: service.page,
                                                            }}
                                                        />
                                                    </div>
                                                ) : null}
                                                {service?.treeChildren
                                                    ?.length ? (
                                                    service.hasChild ? (
                                                        service.treeChildren.map(
                                                            (ser, i) => {
                                                                return (
                                                                    <Fragment
                                                                        key={i}>
                                                                        {ser.page ? (
                                                                            <ButtonComponent
                                                                                buttonClassName={
                                                                                    style[
                                                                                        'treeChildren--button'
                                                                                    ]
                                                                                }
                                                                                button={{
                                                                                    type: 'link',
                                                                                    block: true,
                                                                                    label: ser.title,
                                                                                    ...(ser?.page && {
                                                                                        link: ser.page,
                                                                                    }),
                                                                                }}
                                                                            />
                                                                        ) : (
                                                                            <Heading
                                                                                Tag="h3"
                                                                                className={[
                                                                                    'text-dark',
                                                                                    style[
                                                                                        'treeChildren--button'
                                                                                    ],
                                                                                ].join(
                                                                                    ' ',
                                                                                )}>
                                                                                {
                                                                                    ser.title
                                                                                }
                                                                            </Heading>
                                                                        )}
                                                                        <ServicesButtons
                                                                            services={
                                                                                ser.treeChildren
                                                                            }
                                                                            wrapperClassName={
                                                                                style[
                                                                                    'service-buttons-wrapper'
                                                                                ]
                                                                            }
                                                                            desktopWidth="2"
                                                                        />
                                                                    </Fragment>
                                                                );
                                                            },
                                                        )
                                                    ) : (
                                                        <ServicesButtons
                                                            services={
                                                                service.treeChildren
                                                            }
                                                            wrapperClassName={
                                                                style[
                                                                    'service-buttons-wrapper'
                                                                ]
                                                            }
                                                            desktopWidth="2"
                                                        />
                                                    )
                                                ) : null}
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                        );
                    })}
                    {boxWithMargins ? <div {...className('mb-20')} /> : null}
                </>
            )}
        </>
    );
}

export const query = graphql`
    fragment DatoCmsServicesBoxSection on DatoCmsServicesBoxSection {
        title
        boxWithMargins
        services {
            ...DatoCmsService
            treeChildren {
                ...DatoCmsService
                treeChildren {
                    ...DatoCmsService
                }
            }
        }
        serviceChilds {
            treeChildren {
                ...DatoCmsService
                treeChildren {
                    ...DatoCmsService
                }
            }
        }
        sectorServices {
            ...DatoCmsService
        }
    }
`;
